import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../../style/style.css";
import logo from "../../assets/logoresize.png";
import backgroundImg from "../../assets/background_novo.png";
import axios from 'axios';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import 'primeicons/primeicons.css';

const Login = () => {
  const [dataLogin, setDataLogin] = useState({ cpf: '', secretkey: '' })
  const [showPassword, setShowPassword] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const urlSys = localStorage.getItem('urlSys');
  const currentTime = Date.now();

  const notifySuccess = (message) => toast.success(message, {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

  const notifyError = (message) => toast.error(message, {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

  useEffect(() => {
    const cookieAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookieAccepted) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };


  const handleClickLongin = async (e) => {
    e.preventDefault();
    
    if (!dataLogin.cpf || !dataLogin.secretkey) {
      notifyError('Por favor, preencha todos os campos!');
      return;
    }

    setLoading(true);
    try {
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      const resposta = await axios.post(
        `${urlSys}post/sys/login`,
        {
          cpf: dataLogin.cpf,
          secretkey: dataLogin.secretkey
        },
        { headers }
      );
      if (resposta.status === 201)
      {
        console.log(resposta.data.token)
        localStorage.setItem('token',resposta.data.token)
        localStorage.setItem('userData',JSON.stringify(resposta.data.user))
        
        localStorage.setItem('user_login_time', currentTime.toString());
        notifySuccess('Login realizado com sucesso!');
        setTimeout(() => {
          window.location.href = `${window.location.origin}/home`;
        }, 1000);
      }
      else if(resposta.status === 401) {
        notifyError('Usuário bloqueado. Entre em contato com o administrador.');
      }
      else if(resposta.status === 402){
        notifyError('Usuário ou senha incorretos!');
      } 
      else if(resposta.status === 400){
        notifyError('Dados inválidos. Verifique as informações.');
      }
      else if(resposta.status === 500){
        notifyError('Erro interno do servidor. Tente novamente.');
      }
    } catch (error) {
      console.error(error);
      if (error.response?.status === 401) {
        notifyError('Usuário ou senha incorretos!');
      } else if (error.response?.status === 403) {
        notifyError('Acesso negado!');
      } else {
        notifyError('Erro ao conectar com o servidor. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };
  
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleClickLongin(event);
    }
  };

  const formatCPF = (value) => {
    if (!value) return value;
    
    // Remove tudo que não é número
    const cleaned = value.replace(/\D/g, '');
    
    // Aplica a máscara XXX.XXX.XXX-XX
    if (cleaned.length <= 3) {
      return cleaned;
    } else if (cleaned.length <= 6) {
      return `${cleaned.slice(0, 3)}.${cleaned.slice(3)}`;
    } else if (cleaned.length <= 9) {
      return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;
    } else {
      return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9, 11)}`;
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'cpf') {
      // Remove caracteres não numéricos e limita a 11 dígitos
      const cleanValue = value.replace(/\D/g, "").substring(0, 11);
      setDataLogin(prevState => ({
        ...prevState,
        [name]: cleanValue
      }));
    } else {
      setDataLogin(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateCPF = (cpf) => {
    // Remove caracteres não numéricos
    const cleaned = cpf.replace(/\D/g, '');
    
    // Verifica se tem 11 dígitos
    if (cleaned.length !== 11) return false;
    
    // Verifica se todos os dígitos são iguais
    if (/^(\d)\1{10}$/.test(cleaned)) return false;
    
    // Validação dos dígitos verificadores
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cleaned[i]) * (10 - i);
    }
    let digit1 = 11 - (sum % 11);
    if (digit1 > 9) digit1 = 0;
    
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cleaned[i]) * (11 - i);
    }
    let digit2 = 11 - (sum % 11);
    if (digit2 > 9) digit2 = 0;
    
    return digit1 === parseInt(cleaned[9]) && digit2 === parseInt(cleaned[10]);
  };

  return (
    <>
      <body className="my-login-page">
        <section className="min-vh-100 d-flex flex-column position-relative" style={{ overflow: 'hidden' }}>
          <div style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${backgroundImg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: 0.5,
            zIndex: 0
          }} />
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(135deg, #17395e 0%, #ffffff 50%, #17395e 100%)',
            opacity: 0.85,
            zIndex: 1
          }} />
          <div className="container-fluid flex-grow-1 d-flex align-items-center justify-content-center py-5 position-relative" style={{ zIndex: 2 }}>
            <div className="row w-100 align-items-center justify-content-center">
              
              {/* Coluna central - Login */}
              <div className="col-lg-4 col-md-6 col-sm-8 d-flex justify-content-center">
                <div className="card-wrapper w-100" style={{ maxWidth: '450px' }}>
                  <div className="card shadow-lg border-0" style={{ 
                    borderRadius: '20px', 
                    overflow: 'hidden',
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)'
                  }}>
                    
                    {/* Header do card com logo */}
                    <div className="card-header text-white text-center py-4 header-main">
                      <Link to='https://transtecworld.com/' className="text-decoration-none">
                        <img src={logo} alt="Logo Transtec" style={{ maxHeight: '80px' }} className="img-fluid" />
                      </Link>
                      <h4 className="mt-3 mb-0 fw-bold">Sistema Operacional</h4>
                    </div>
                    
                    <div className="card-body p-5">
                      <h5 className="card-title text-center mb-4 fw-bold" style={{ 
                        color: '#17395e',
                        fontSize: '1.8rem'
                      }}>
                        <i className="bi bi-person-circle me-2"></i>
                        Acesso ao Sistema
                      </h5>
                      
                      <form onKeyDown={handleKeyDown}>
                        <div className="form-floating mb-4">
                          <input 
                            type="text" 
                            name="cpf"
                            className="form-control form-control-lg shadow-sm" 
                            id="floatingInput"
                            placeholder="111.111.111-11" 
                            onChange={handleChange} 
                            value={formatCPF(dataLogin.cpf)} 
                            maxLength={14} 
                            required 
                            disabled={loading}
                            style={{
                              borderColor: '#17395e',
                              borderWidth: '2px',
                              borderRadius: '15px',
                              fontSize: '1.1rem'
                            }}
                          />
                          <label htmlFor="floatingInput" style={{ color: '#17395e', fontWeight: '600' }}>
                            <i className="bi bi-card-text me-2"></i>CPF
                          </label>
                        </div>
                        
                        <div className="form-floating position-relative mb-4">
                          <input 
                            type={showPassword ? "text" : "password"} 
                            name="secretkey"
                            className="form-control form-control-lg shadow-sm" 
                            id="floatingPassword"
                            placeholder="Senha" 
                            onChange={handleChange} 
                            value={dataLogin.secretkey} 
                            required 
                            disabled={loading}
                            style={{
                              borderColor: '#17395e',
                              borderWidth: '2px',
                              borderRadius: '15px',
                              fontSize: '1.1rem',
                              paddingRight: '60px'
                            }}
                          />
                          <label htmlFor="floatingPassword" style={{ color: '#17395e', fontWeight: '600' }}>
                            <i className="bi bi-lock me-2"></i>Senha
                          </label>
                          <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            className="btn position-absolute"
                            style={{ 
                              top: "50%", 
                              right: "15px", 
                              transform: "translateY(-50%)",
                              color: '#17395e',
                              zIndex: 5,
                              border: 'none',
                              background: 'transparent'
                            }}
                            disabled={loading}
                          >
                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                          </button>
                        </div>
                        
                        <div className="d-grid gap-2 mb-4">
                          <button 
                            type="button" 
                            className="btn btn-lg shadow-sm" 
                            onClick={handleClickLongin}
                            disabled={loading || !dataLogin.cpf || !dataLogin.secretkey}
                            style={{
                              background: loading ? '#cccccc' : 'linear-gradient(135deg, #17395e 0%, #0f263e 100%)',
                              border: 'none',
                              color: 'white',
                              padding: '15px 20px',
                              borderRadius: '15px',
                              fontWeight: 'bold',
                              fontSize: '1.2rem',
                              boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                              transition: 'all 0.3s ease',
                              cursor: loading ? 'not-allowed' : 'pointer'
                            }}
                            onMouseOver={(e) => {
                              if (!loading && dataLogin.cpf && dataLogin.secretkey) {
                                e.target.style.transform = 'translateY(-3px)';
                                e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.25)';
                              }
                            }}
                            onMouseOut={(e) => {
                              e.target.style.transform = 'translateY(0)';
                              e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15)';
                            }}
                          >
                            {loading ? (
                              <>
                                <i className="pi pi-spin pi-spinner me-2"></i>
                                Entrando...
                              </>
                            ) : (
                              <>
                                <i className="bi bi-box-arrow-in-right me-2"></i>
                                Entrar no Sistema
                              </>
                            )}
                          </button>
                        </div>

                        {/* Informações adicionais */}
                        <div className="text-center">
                          <small className="text-muted">
                            <i className="bi bi-shield-check me-1"></i>
                            Acesso seguro e criptografado
                          </small>
                        </div>
                      </form>
                    </div>

                    {/* Footer do card */}
                    <div className="card-footer bg-transparent text-center py-3" style={{
                      borderTop: '1px solid rgba(64, 65, 70, 0.2)'
                    }}>
                      <small className="text-muted">
                        <i className="bi bi-question-circle me-1"></i>
                        Problemas para acessar? Entre em contato com o suporte
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          
          {/* Rodapé da página */}
          <footer className="mt-auto position-relative" style={{
            background: 'linear-gradient(90deg, #17395e 0%, #0f263e 50%, #17395e 100%)',
            color: 'white',
            zIndex: 2,
            textAlign: 'center',
            padding: '20px 0',
            fontSize: '1rem',
            borderTop: '3px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 -4px 15px rgba(0,0,0,0.1)'
          }}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <i className="bi bi-c-circle me-2"></i>
                  <strong>Copyright &copy; 2025 &mdash; Transtec World</strong>
                </div>
                <div className="col-12 mt-2">
                  <small className="opacity-75">
                    Sistema de Gestão Operacional | Versão 2.0
                  </small>
                </div>
              </div>
            </div>
          </footer>
        </section>
      </body>

      {/* Banner de cookies */}
      {showBanner && (
        <div className="position-fixed bottom-0 start-0 end-0 p-3" style={{
          background: 'linear-gradient(90deg, #17395e 0%, #0f263e 100%)',
          color: 'white',
          marginBottom: '100px', // Espaço para não sobrepor o footer
          boxShadow: '0 -4px 15px rgba(0,0,0,0.2)',
          zIndex: 1050
        }}>
          <div className="container d-flex justify-content-between align-items-center flex-wrap">
            <div className="me-3">
              <i className="bi bi-info-circle me-2"></i>
              <strong>Política de Cookies:</strong> Este site usa cookies para melhorar sua experiência. 
              Ao continuar navegando, você aceita o uso de cookies.
            </div>
            <button
              onClick={acceptCookies}
              className="btn btn-light shadow-sm"
              style={{
                borderRadius: '20px',
                padding: '8px 25px',
                fontWeight: 'bold',
                transition: 'all 0.3s ease',
                border: '2px solid rgba(255, 255, 255, 0.2)'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              <i className="bi bi-check-circle me-1"></i>
              Aceitar Cookies
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;

